import { defineComponent as _defineComponent } from 'vue'
import { useImage } from '@/shared/composables/image'
import { EventBaseCard } from '@/shared/ui/cards'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import { ref } from 'vue'
import { EventPreview } from '@/enitites/event/model/types'
import IconLike from '@/shared/icons/IconLike.vue'
import IconArrowRight from '@/shared/icons/IconArrowRight.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventPreviewBaseCardDesktop',
  props: {
    previewEvent: null
  },
  setup(__props: any) {

const props = __props as {
  previewEvent: EventPreview
};

const { getImageById } = useImage()


const eventSharedLink = `${window.location.origin}/event/${props.previewEvent.id}`

const sharedSMLinksMap = new Map([
  ['facebook', `https://www.facebook.com/sharer/sharer.php?u=${eventSharedLink}`],
  ['twitter', `https://twitter.com/intent/tweet?text=${props.previewEvent.title}&url=${eventSharedLink}`],
])
const titleWhiteSpaceValue = ref<'normal' | 'nowrap'>('nowrap')

return { __sfc: true,getImageById, props, eventSharedLink, sharedSMLinksMap, titleWhiteSpaceValue, EventBaseCard, BKSvgIcon, IconLike, IconArrowRight }
}

})